<template>
	<transition name="fade" v-if="config.show">
		<div class="modal-box">
			<div class="modal p-0">
				<div class="modal-header clearfix">
					<h2 class="pull-left">회원등록</h2>
					<a class="close" @click="$emit('close')">&times;</a>
				</div>

				<div v-show="step==1" class="modal-body p-15" style="min-height: 1px;">
					<p>
						-( <img class="v-mid" src="images/s-check.png" alt="체크"> )은(는) 필수 입력 사항입니다.
					</p>
					<p class="m-t-30 m-b-0">가입양식</p>
					<div class="round m-b-10">
						<div class="input-group full-width">
							<span class="input-group-addon label bg-blue v-mid text-white">
								<img class="v-mid m-r-10" src="images/s-check.png" alt=""> 이름
							</span>
							<input class="form-control full-width" type="text" ref="mberName" v-model="member.mberName">
						</div>
					</div>
					<div class="round">
						<div class="input-group full-width">
							<span class="input-group-addon label bg-blue v-mid text-white">
								<img class="v-mid m-r-10" src="images/s-check.png" alt=""> 아이디
							</span>
							<input class="form-control full-width round b-l-0 m-r-5" type="text" ref="mberId"
								v-model="member.mberId" @change="isDuplicateId = true">
							<span class="input-group-addon button v-mid text-white">
								<button class="btn btn-red round m-l-5"
									@click="checkDupliateId()" v-if="isDuplicateId" ref="duplicateId">확인</button>
								<button class="btn btn-red round m-l-5 btn-disabled" disabled v-else>완료</button>
							</span>
						</div>
					</div>
					<span class="text-lightgray">(6~20자의 영문, 숫자를 혼용할 수 있습니다.)</span>
					<div class="round m-b-10">
						<div class="input-group full-width">
							<span class="input-group-addon label bg-blue v-mid text-white">
								<img class="v-mid m-r-10" src="images/s-check.png" alt=""> 비밀번호
							</span>
							<input class="form-control full-width" type="password" ref="password" v-model="member.password">
							<!-- <span class="input-group-addon button v-mid text-white">
								<button class="btn btn-red round m-l-5" @click="setRandomPassword()">임시 비밀번호</button>
							</span> -->
						</div>
					</div>
					<div class="round m-t-10">
						<div class="input-group full-width">
							<span class="input-group-addon label bg-blue v-mid text-white">
								<img class="v-mid m-r-10" src="images/s-check.png" alt=""> 이메일
							</span>
							<input class="form-control full-width" type="text" ref="email" v-model="member.email">
						</div>
					</div>
					<div class="round m-t-10">
						<div class="input-group full-width">
							<span class="input-group-addon label bg-blue v-mid text-white">
								<img class="v-mid m-r-10" src="images/s-check.png" alt=""> 휴대전화
							</span>
							<input class="form-control full-width" type="text" ref="mobileNum"
								placeholder="'-' 없이 번호 입력" v-model="member.mobileNum">
						</div>
					</div>
				</div>

				<!-- <div v-show="step==2" class="modal-body p-15" style="min-height: 1px;">
					<p>
						-( <img class="v-mid" src="images/s-check.png" alt="체크"> )은(는) 필수 입력 사항입니다.
					</p>
					<div class="round m-b-5">
						<div class="input-group full-width">
							<span class="input-group-addon label bg-blue v-mid text-white">
								<img class="v-mid m-r-10" src="images/s-check.png" alt=""> 직업
							</span>
							<select class="form-control" v-model="member.workCode" ref="workCode" @change="setJobQuestions">
								<option value="">==== 직업을 선택해주세요 ====</option>
								<option v-for="job in jobs" :key="`job-code-list-${hash(job)}`" :value="job.code">{{job.codeNm}}</option>
							</select>
						</div>
					</div>
					<span class="text-darkgray" style="display:inline-block;line-height: 1.2;">
						<span class="text-blue">&lt;직업 구분 선택 시 유의 사항&gt;</span><br>
						전국 초·중·고등 교사 및 교육전문직(장학사, 장학관, 교육연구사, 교육연구관 등)은<br>
						'교사'로 선택하고, 초·중·고등학교의 기간제 교사, 시간 강사, 유치원 교사는<br>
						'일반'으로 선택해 주십시오.
					</span>
					<div class="round m-b-10">
						<div class="input-group full-width">
							<span class="input-group-addon label bg-blue v-mid text-white">
								<img class="v-mid m-r-10" src="images/s-check.png" alt=""> 기관명
							</span>
							<input class="form-control full-width round b-l-0 m-r-5" type="text">
							<span class="input-group-addon button v-mid text-white">
								<button class="btn btn-red round m-l-5">기관검색</button>
							</span>
						</div>
					</div>
					<div class="round m-b-10" v-for="(question) in jobQuestions" :key="`job-question-${hash(question)}`">
						<div class="input-group full-width">
							<span class="input-group-addon label bg-blue v-mid text-white">
								<img class="v-mid m-r-10" src="images/s-check.png" :alt="`${question.workInfoName}`"> {{question.workInfoName}}
							</span>
							<input class="form-control full-width" type="text" v-if="question.type == 'text'"
								@change="setJobAnswer($event, question)">
							<select class="form-control full-width" type="text" v-if="question.type == 'select'" @change="setJobAnswer($event, question)">
								<option value="">==== 선택 사항을 선택해주세요 ====</option>
								<option v-for="option in question.option.split('/')" :key="`job-question-${hash(question)}-option-${option}`" :value="option">{{option}}</option>
							</select>
						</div>
					</div>
				</div> -->

				<div v-show="step==2" class="modal-body p-15" style="min-height: 1px;">
					<p>
						-( <img class="v-mid" src="images/s-check.png" alt="체크"> )은(는) 필수 입력 사항입니다.
					</p>
					<p class="m-t-30 m-b-0">가입양식</p>
					<!-- <div class="round m-b-10">
						<div class="input-group full-width">
							<span class="input-group-addon label not bg-blue v-mid text-white">
								직장 전화
							</span>
							<input class="form-control full-width" type="text" v-model="member.phoneNum" placeholder="'-' 없이 번호 입력">
						</div>
					</div> -->
					<!-- <div class="round m-b-10">
						<div class="input-group full-width">
							<span class="input-group-addon label not bg-blue v-mid text-white">
								직장 주소
							</span>
							<input class="form-control full-width round b-l-0 m-r-5" type="text" placeholder="우편번호" v-model="member.zipcode">
							<span class="input-group-addon button v-mid text-white">
								<button class="btn btn-red round m-l-5" @click="openAddressSearch">우편검색</button>
							</span>
						</div>
					</div> -->
					<!-- <div class="round on-border m-b-10">
						<div class="input-group full-width">
							<input class="form-control full-width no-border m-r-5" type="text" placeholder="기본주소" v-model="member.addr">
						</div>
					</div>
					<div class="round on-border m-b-10">
						<div class="input-group full-width">
							<input class="form-control full-width no-border m-r-5" type="text" placeholder="상세주소" v-model="member.detailAddr">
						</div>
					</div> -->
					<div class="round round m-b-10">
						<div class="input-group full-width">
							<span class="input-group-addon label bg-blue v-mid text-white">
								<img class="v-mid m-r-10" src="images/s-check.png" alt=""> 문자수신 여부
							</span>
							<span class="input-group-addon v-mid clearfix">
								<div class="checkbox">
									<input id="chek1" type="radio" name="check1"
										@click="checkMobileRecv(true)" :checked="member.mobileRecvEnable">
									<label for="chek1">수신 허용</label>
								</div>
								<div class="checkbox">
									<input id="chek2" type="radio" name="check1"
										@click="checkMobileRecv(true)" :checked="!member.mobileRecvEnable">
									<label for="chek2" style="border-radius:0 5px 5px 0">수신 허용 안함</label>
								</div>
							</span>
						</div>
					</div>
					<div class="round m-t-10">
						<div class="input-group full-width">
							<span class="input-group-addon label bg-blue v-mid text-white">
								<img class="v-mid m-r-10" src="images/s-check.png" alt=""> 전자우편수신여부
							</span>
							<span class="input-group-addon v-mid clearfix">
								<div class="checkbox">
									<input id="chek3" type="radio" name="check2"
										@click="checkEmailRecv(true)" :checked="member.emailRecvEnable">
									<label for="chek3">수신 허용</label>
								</div>
								<div class="checkbox">
									<input id="chek4" type="radio" name="check2"
										@click="checkEmailRecv(false)" :checked="!member.emailRecvEnable">
									<label for="chek4" style="border-radius:0 5px 5px 0">수신 허용 안함</label>
								</div>
							</span>
						</div>
					</div>
				</div>

				<div v-show="step==3" class="modal-body p-15" style="min-height: 1px;">
					<p>
						-( <img class="v-mid" src="images/s-check.png" alt="체크"> )은(는) 필수 입력 사항입니다.
					</p>
					<!-- <div class="round m-b-10">
						<div class="input-group full-width">
							<span class="input-group-addon label bg-blue v-mid text-white">
								<img class="v-mid m-r-10" src="images/s-check.png" alt=""> 강사권한
							</span>
							<span class="input-group-addon v-mid clearfix">
								<div class="checkbox">
									<input id="use1" type="radio" name="use1" :checked="member.instEnable" @click="member.instEnable=true">
									<label for="use1">사용</label>
								</div>
								<div class="checkbox">
									<input id="use2" type="radio" name="use1" :checked="!member.instEnable" @click="member.instEnable=false">
									<label for="use2" style="border-radius:0 5px 5px 0">미사용</label>
								</div>
							</span>
						</div>
					</div> -->
					<!-- <template v-if="member.instEnable">
						<div class="round on-border m-b-10">
							<div class="input-group full-width">
								<select class="form-control full-width no-border" v-model="authSelected" @change="addAuthAllotList">
									<option value="">권한선택</option>
									<option v-for="auth in authList.filter(e=>e.type==='강사')"
											:key="`auth-id-option-${auth.authId}`" :value="auth.authId">
										{{auth.authName}}
									</option>
								</select>
							</div>
						</div>
						<div class="round on-border m-b-10">
							<div class="input-group p-5">
								<span class="input-group-addon" style="visibility: hidden">_</span>
								<span class="input-group-addon"
									v-for="(auth, idx) in member.authAllotList.map(e=>getAuth(e.authId)).filter(e=>e.type==='강사')"
									:key="`auth-allot-list-${hash(auth)}-${idx}`">
									{{getAuth(auth.authId).authName}}
									<a class="m-r-5 text-blue text-bold" @click="removeAuthId(authId)">&times;</a>
								</span>
							</div>
						</div>

						<div class="round m-b-10">
							<div class="input-group full-width">
								<span class="input-group-addon label not bg-blue v-mid text-white">
									담당국어원
								</span>
								<input class="form-control full-width round b-l-0" type="text" v-model="localKorInst">
							</div>
						</div>
						<div class="round on-border m-b-10">
							<div class="input-group full-width">
								<span class="input-group-addon label not bg-blue v-mid text-white">
									좌정보
								</span>
								<span class="input-group-addon">
									<select class="form-control full-width no-border" v-model="bankName">
										<option value="">은행선택</option>
										<option value="국민은행">국민은행</option>
										<option value="kb은행">kb은행</option>
										<option value="신한은행">신한은행</option>
										<option value="카카오뱅크">카카오뱅크</option>
									</select>
								</span>
								<span class="input-group-addon">
									<input class="form-control full-width b-r-0 b-b-0 b-t-0" type="text" placeholder="계좌번호" v-model="accountInfo">
								</span>
								<span class="input-group-addon" style="width:100px;">
									<input class="form-control full-width b-r-0 b-b-0 b-t-0" type="text" placeholder="계좌주" v-model="depositor">
								</span>
							</div>
						</div>
						<div class="round m-b-10">
							<div class="input-group full-width">
								<span class="input-group-addon label not bg-blue v-mid text-white">
									이력서
								</span>
								<span class="input-group-addon">
									<div class="send-box full-width">
										<div class="send-search-box clearfix">
											<div class="search-box pull-left">
												<input id="file" type="file" style="display: none;" ref="refCarrer" @change="changeUploadFile">
												<input id="file-text" class="form-control round full-width m-b-0"
													type="text" placeholder="파일첨부" :value="fileName" readonly>
											</div>
											<label for="file" class="btn bg-darkgray plus round pull-right f-12">
												<img class="v-mid" src="images/plus.png" width="15" alt="">
											</label>
										</div>
									</div>
								</span>
							</div>
						</div>

						<div class="round m-b-10">
							<div class="input-group full-width">
								<span class="input-group-addon label not bg-blue v-mid text-white">
									약력
								</span>
								<input class="form-control full-width round b-l-0" type="text" v-model="career">
							</div>
						</div>
					</template>
					-->
					<div class="round m-b-10">
						<div class="input-group full-width">
							<span class="input-group-addon label bg-blue v-mid text-white">
								<img class="v-mid m-r-10" src="images/s-check.png" alt=""> 관리자 권한
							</span>
							<span class="input-group-addon v-mid clearfix">
								<div class="checkbox">
									<input id="use3" type="radio" name="use3" :checked="member.adminEnable" @click="member.adminEnable=true">
									<label for="use3">사용</label>
								</div>
								<!-- <div class="checkbox">
									<input id="use4" type="radio" name="use3" :checked="!member.adminEnable" @click="member.adminEnable=false">
									<label for="use4" style="border-radius:0 5px 5px 0">미사용</label>
								</div> -->
							</span>
						</div>
					</div> 
					<template v-if="member.adminEnable">
						<div class="round on-border m-b-10">
							<div class="input-group full-width">
								<select class="form-control full-width no-border" v-model="authSelected" @change="addAuthAllotList">
									<option value="">권한선택</option>
									<option v-for="auth in authList.filter(e=>e.type==='관리자')"
											:key="`auth-id-option-${auth.authId}`" :value="auth.authId">
										{{auth.authName}}
									</option>
								</select>
							</div>
						</div>
						<div class="round on-border m-b-10">
							<div class="input-group p-5">
								<span class="input-group-addon" style="visibility: hidden">_</span>
								<span class="input-group-addon"
									v-for="(auth, idx) in member.authAllotList.map(e=>getAuth(e.authId)).filter(e=>e.type==='관리자')"
									:key="`auth-allot-list-${hash(auth)}-${idx}`">
									{{getAuth(auth.authId).authName}}
									<a class="m-r-5 text-blue text-bold" @click="removeAuthId(authId)">&times;</a>
								</span>
							</div>
						</div>
					</template>
				</div>

				<div class="modal-footer p-15 m-t-30 clearfix">
					<button v-if="step>1" @click="prevStep" class="btn half-width pull-left" type="button">&nbsp;&nbsp;이전&nbsp;&nbsp;</button>
					<button v-if="step<4" @click="nextStep" class="btn bg-deepblue text-white half-width pull-right" type="button">&nbsp;&nbsp;다음&nbsp;&nbsp;</button>
					<button v-if="step==4" class="btn bg-deepblue text-white half-width pull-right" type="button" @click="regiMember()">&nbsp;&nbsp;회원등록&nbsp;&nbsp;</button>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
import axios from 'axios'
import server from '../statics/server'
import fnGetJobData from '../mixins/fnGetJobData'
import fnAddressSearch from '../mixins/fnAddressSearch.js'

export default {
	name: "ModalUserRegister",

	mounted: async function() {
		this.getAuthList();
	},
	mixins: [ fnGetJobData, fnAddressSearch ],
	default: function() {
		return {
			name: this.name,
			show: false,
		}
	},

	props: {
		config: Object
	},

	data: function () {
		return {
			step: 1,
			isDuplicateId: true,
			authSelected: "",
			authList: [],

			uploadFile: false,

			localKorInst: '',
			bankName: '',
			depositor: '',
			accountInfo: '',
			fileName: '',
			career: '',
			resumeFile: '',

			member: {
				mberName: "",
				mberId: "",
				password: "",
				email: "",
				mobileNum: "",
				workCode: "",
				phoneNum: "",
				zipcode: "",
				addr: "",
				detailAddr: "",
				mobileRecvEnable: true,
				emailRecvEnable: true,
				instEnable: false,
				adminEnable: true,
				workInfoList: [],
				authAllotList: [],
				instInfoList: []
			},
			jobQuestions: [],
			submit: false
		}
	},
	methods: {
		setAddress: function(zipcode, addr1, addr2) {
			this.member.addr = addr1;
			this.member.detailAddr = addr2;
			this.member.zipcode = zipcode;
		},
		getAuth:function(authId) {
			return this.authList.find(e=>e.authId===authId);
		},
		// auth 정보
		getAuthList: async function() {
			try {
				const { data } = await axios.post(`${server.addr()}${server.api.AUTH}`, {});
				this.authList = data.list;
			} catch(e) {
				// TODO: error exception
			}
		},
		// 모바일 전송 가능 여부 체크
		checkMobileRecv: function(bool) {
			this.member.mobileRecvEnable = bool;
		},
		// 이메일 전송 가능 여부 체크
		checkEmailRecv: function(bool) {
			this.member.emailRecvEnable = bool;
		},
		// 직업 전용 질문 설정
		setJobQuestions: async function() {
			const { workCode } = this.member;

			try {
				const { data } = await axios.post(`${server.addr()}${server.api.WORK_INFO}`, { workCode });
				this.jobQuestions = data.list;
				this.workInfoList = [];
			} catch (e) {
				// DOTO: error exception
			}
		},
		setJobAnswer: function($event, question) {
			const { value } = $event.target;

			const answer = this.member.workInfoList.find(e=>e.itemName == question.workInfoName);
			if(!answer) {
				this.member.workInfoList.push({
					itemName: question.workInfoName,
					itemValue: value
				});
			} else {
				this.$set(answer, "itemValue", value);
			}
		},
		prevStep: function() {
			this.step -= 1;
		},
		nextStep: function() {
			switch(this.step) {
				case 1:
					if( !this.validateMberName() || !this.validateMberId() ||
						!this.validateDuplicateId() || !this.validatePassword() ||
						!this.validateEmail() || !this.validateMobileNum()) {
						return;
					}
					break;
				case 3: break;
				// default: return;
				default: break;
			}
			this.step += 1;
		},
		// 아이디 중복검사
		checkDupliateId: async function() {
			let {mberId} = this.member;
			mberId = this.member.mberId = mberId.trim();
			if(!this.validateMberId()) return;
			if(mberId) {
				axios.post(server.addr()+server.api.MBER+"/"+mberId).then((response) => {
					if(response.data.return) {
						this.$parent.modals.ModalAlert.msg = "회원아이디가 이미 존재합니다.";
						this.$parent.modals.ModalAlert.show = true;
					} else {
						this.isDuplicateId = false;
					}
				})
			}
		},
		setRandomPassword: function() {
			let result           = '';
			const characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
			for ( let i = 0; i < 8; i++ ) {
				result += characters.charAt(Math.floor(Math.random() * characters.length));
			}

			this.member.password = result;
		},
		// 직업 권한 추가
		addAuthAllotList: function(event) {
			const { value } = event.target;
			if(value === "") return;
			this.authSelected = "";

			if(this.member.authAllotList.find((el) => (el.authId === parseInt(value)))) return;
			this.member.authAllotList.push({authId:parseInt(value)});
		},
		// 직업 권한 제거
		removeAuthId: function(authId) {
			const idx = this.mebmer.authAllotList.findIndex(e=>e.authId===authId);
			this.mebmer.authAllotList.splice(idx, 1,);
		},
		changeUploadFile: async function() {
			if(this.uploadFile) return;
			this.uploadFile = true;
			const formData = new FormData();
			formData.append("file", this.$refs.refCarrer.files[0])

			try {
				const { data } = await axios.post(`${server.addr()}/file`, formData, {
					'Content-type': 'multipart/form-data'
				});
				this.fileName = this.$refs.refCarrer.files[0].name;
				this.resumeFile = data;
				this.uploadFile = false;
			} catch(e) {
				this.modals.ModalAlert.msg = "이력서 업로드 중 오류가 발생했습니다. 잠시 후 다시 시도해주세요.";
				this.modals.ModalAlert.show = true;
			}
		},
		// 맴버 저장
		regiMember: async function() {
			if(this.uploadFile) return;
			this.submit = true;
			// TODO: validate Authenticate
			if (this.member.instEnable) {
				const { localKorInst, bankName, depositor, accountInfo, fileName, career } = this;
				this.member.instInfoList = [{ localKorInst, bankName, depositor, accountInfo, fileName, career }]
			}
			try {
				await axios.put(`${server.addr()}${server.api.MBER}`, [{...this.member, emailRecvEnable:this.member.emailRecvEnable?1:0, instEnable:this.member.instEnable?1:0, mobileRecvEnable:this.member.mobileRecvEnable?1:0, adminEnable:this.member.adminEnable?1:0}]);
				this.$emit("refresh");
				this.$emit("close");
			} catch(e) {
				// TODO: error exception
			}
			this.submit = false;
		},

		// 유효성 검사 매소드
		validateMberName: function() {
			if(this.member.mberName.length <= 0) {
				this.$refs["mberName"].style = "border-color: #ff3333"
				setTimeout(() => {this.$refs["mberName"].style = ""}, 1500);
				return false;
			}
			return true;
		},
		validateMberId: function() {
			const { mberId } = this.member;
			if(!mberId) {
				this.$refs["mberId"].style = "border-color: #ff3333"
				setTimeout(() => {this.$refs["mberId"].style = ""}, 1500);
				return false;
			}
			return true;
		},
		validateDuplicateId: function() {
			if(this.isDuplicateId) {
				this.$refs["duplicateId"].style = "border-color: #ff3333"
				setTimeout(() => {this.$refs["duplicateId"].style = ""}, 1500);
				return false;
			}

			return true;
		},
		validatePassword: function() {
			if(!this.member.password) {
				this.$refs["password"].style = "border-color: #ff3333"
				setTimeout(() => {this.$refs["password"].style = ""}, 1500);
				return false;
			}
			return true;
		},
		validateEmail: function() {
			const { email } = this.member;

			const emailRegx = /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*.[a-zA-Z]{2,3}$/i;

			if(!email || !emailRegx.test(email)) {
				this.$refs["email"].style = "border-color: #ff3333"
				setTimeout(() => {this.$refs["email"].style = ""}, 1500);
				return false;
			}
			return true;
		},
		validateMobileNum: function() {
			const { mobileNum } = this.member;

			const mobileRegx = /^01[0,1,3,5,7,8,9]\d{7,8}$/;

			if(!mobileNum || !mobileRegx.test(mobileNum)) {
				this.$refs["mobileNum"].style = "border-color: #ff3333"
				setTimeout(() => {this.$refs["mobileNum"].style = ""}, 1500);
				return false;
			}
			return true;
		},
		validateWorkCode: function() {
			if(!this.member.workCode) {
				this.$refs["workCode"].style = "border-color: #ff3333"
				setTimeout(() => {this.$refs["workCode"].style = ""}, 1500);
				return false;
			}
			return true;
		},
		openAddressSearch: function() {
			window.open("/user/jusoPopup.jsp", "popAddressSearch", "width=570,height=420,scrollbars=yes,resizable=yes");
		}
	}
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
	transition: opacity .5s;
}
.fade-enter, .fade-leave-to {
	opacity: 0;
}
.btn-disabled {
	color: #fff !important;
    background-color: #77a7c3 !important;
    border-color: #77a7c3 !important;
}
</style>